"use strict";

require("core-js/modules/es.array.reduce.js");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var core_1 = require("@bodiless/core");

var mobx_react_lite_1 = require("mobx-react-lite");

var lodash_1 = require("lodash");

var ComponentSelector_1 = __importDefault(require("../ComponentSelector"));

var childKeys = function childKeys(node) {
  var aParent = node.path;
  var aCandidates = node.keys.map(function (key) {
    return key.split('$');
  });
  return Object.keys(aCandidates.reduce(function (acc, next) {
    var _a;

    if (next.length <= aParent.length) return acc;

    for (var i = 0; i < aParent.length; i += 1) {
      if (aParent[i] !== next[i]) return acc;
    }

    return __assign(__assign({}, acc), (_a = {}, _a[next[aParent.length]] = true, _a));
  }, {}));
};

var copyNode = function copyNode(source, dest, copyChildren) {
  dest.setData(source.data);

  if (copyChildren) {
    childKeys(source).forEach(function (key) {
      return copyNode(source.child(key), dest.child(key), true);
    });
  }
};

var withContentLibrary = function withContentLibrary(options) {
  return function (Component) {
    var _a = options.DisplayComponent,
        DisplayComponent = _a === void 0 ? Component : _a,
        _b = options.Selector,
        Selector = _b === void 0 ? ComponentSelector_1.default : _b,
        useLibraryNode = options.useLibraryNode,
        useMeta = options.useMeta,
        _c = options.useOverrides,
        useOverrides = _c === void 0 ? function () {} : _c;

    var useMenuOptions = function useMenuOptions(props) {
      var targetNode = core_1.useNode().node;
      var libraryNode = useLibraryNode(props).node;
      var keys = childKeys(libraryNode);
      var components = keys.map(function (key) {
        var node = libraryNode.child(key);

        var ComponentWithNode = function ComponentWithNode() {
          return react_1.default.createElement(core_1.NodeProvider, {
            node: node
          }, react_1.default.createElement(DisplayComponent, null));
        };

        ComponentWithNode.displayName = key;
        ComponentWithNode.title = key;
        ComponentWithNode.description = key;

        if (useMeta) {
          var meta = useMeta(node); // If createMeta returns null or undefined, it means do not use this node.

          if (!meta) return null;
          Object.assign(ComponentWithNode, meta);
        }

        return ComponentWithNode;
      }).filter(Boolean);

      var renderForm = function renderForm(_a) {
        var closeForm = _a.closeForm;

        var onSelect = function onSelect(_a) {
          var name = _a[0];

          if (name) {
            copyNode(libraryNode.child(name), targetNode, true);
          }

          closeForm(null);
        };

        return react_1.default.createElement(Selector, {
          closeForm: closeForm,
          onSelect: onSelect,
          components: components
        });
      };

      var form = core_1.useContextMenuForm({
        renderForm: renderForm,
        hasSubmit: false
      });
      var baseOption = {
        name: 'content-library',
        group: 'content-library-group',
        label: 'Library',
        groupLabel: 'Content',
        groupMerge: 'merge',
        icon: 'account_balance',
        local: true,
        global: false,
        formTitle: 'Content Library',
        formDescription: 'Select the content you wish to insert.',
        isHidden: !components.length
      };

      var finalOption = __assign(__assign(__assign({}, baseOption), useOverrides(props)), {
        handler: function handler() {
          return form;
        }
      });

      return core_1.createMenuOptionGroup(finalOption);
    };

    return lodash_1.flow(core_1.withMenuOptions({
      useMenuOptions: useMenuOptions,
      name: 'Content Library'
    }), mobx_react_lite_1.observer)(Component);
  };
};

exports.default = withContentLibrary;